import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormGroup, FormBuilder, Validators, FormArray } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { Select } from "@ngxs/store";
import { Observable } from "rxjs";
import { Subscription } from "rxjs";
import { AdminService } from "src/app/injectable/admin.service";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { ServiceInsertRequest } from "../show-services/service-insert-request";
import { ModifyServiceState } from "./modify-service-state";

@Component({
  selector: "app-modify-service",
  templateUrl: "./modify-service.component.html",
  styleUrls: ["./modify-service.component.scss"],
})
export class ModifyServiceComponent implements OnInit, OnDestroy {
  TRANSLATES_META: any[] = [
    {
      languageLabel: "Inglese",
      languageCode: "EN",
    },
    {
      languageLabel: "Italiano",
      languageCode: "IT",
    },
    {
      languageLabel: "Francese",
      languageCode: "FR",
    },
    {
      languageLabel: "Portoghese",
      languageCode: "PT",
    },
    {
      languageLabel: "Spagnolo",
      languageCode: "ES",
    },
    {
      languageLabel: "Tedesco",
      languageCode: "DE",
    },
  ];

  @Select(ModifyServiceState.service) service$: Observable<any>;

  loading = false;
  sub = false;
  public logoBase64: string = null;
  private subscription: Subscription;
  translatesFormGroup: FormGroup;
  logoFormGroup: FormGroup;
  areaFormGroup: FormGroup;
  areaID: number;
  localIDService: number = null;
  lateServicesType: any;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private genericErrorModalService: GenericErrorModalService,
    private snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    try {
      this.route.params.subscribe((params) => {
        this.localIDService = Number(params["id"]);
      });
    } catch (e) {}
    this.translatesFormGroup = this.formBuilder.group({
      url: [null],
      translates: this.formBuilder.array([
        this.formBuilder.group({
          subject: ["", Validators.required],
          content: ["", Validators.required],
          lang: [this.TRANSLATES_META[0].languageCode, Validators.required],
          popupMsg: "",
          idAlertnow: "",
          id: "",
        }),
        this.formBuilder.group({
          subject: ["", Validators.required],
          content: ["", Validators.required],
          lang: [this.TRANSLATES_META[1].languageCode, Validators.required],
          popupMsg: "",
          idAlertnow: "",
          id: "",
        }),
        this.formBuilder.group({
          subject: ["", Validators.required],
          content: ["", Validators.required],
          lang: [this.TRANSLATES_META[2].languageCode, Validators.required],
          popupMsg: "",
          idAlertnow: "",
          id: "",
        }),
        this.formBuilder.group({
          subject: ["", Validators.required],
          content: ["", Validators.required],
          lang: [this.TRANSLATES_META[3].languageCode, Validators.required],
          popupMsg: "",
          idAlertnow: "",
          id: "",
        }),
        this.formBuilder.group({
          subject: ["", Validators.required],
          content: ["", Validators.required],
          lang: [this.TRANSLATES_META[4].languageCode, Validators.required],
          popupMsg: "",
          idAlertnow: "",
          id: "",
        }),
        this.formBuilder.group({
          subject: ["", Validators.required],
          content: ["", Validators.required],
          lang: [this.TRANSLATES_META[5].languageCode, Validators.required],
          popupMsg: "",
          idAlertnow: "",
          id: "",
        }),
      ]),
    });
    //RIPRENDO IL VALORE COSI NEL HTML POSSO TOGLIERE LA URL
    this.lateServicesType = sessionStorage.getItem("latestServiceType");

    if (this.lateServicesType == 2) {
      this.translatesFormGroup.controls["url"].setValidators([
        Validators.required,
      ]);
    }
    this.logoFormGroup = this.formBuilder.group({
      logo: ["", Validators.required],
    });

    this.subscription = this.service$.subscribe((service) => {
      if (!service) this.router.navigate(["/services"]);
      else {
        this.areaID = service["idArea"];
        const translates: any[] = [];
        this.TRANSLATES_META.forEach((element) => {
          const translate = service.translates.find(
            (item) => item.lang == element.languageCode
          );
          let tmpan;
          try {
            tmpan = service.translates[0]["idAlertnow"];
          } catch (e) {}
          if (translate) translates.push(translate);
          else
            translates.push({
              subject: "",
              content: "",
              lang: element.languageCode,
              popupMsg: "",
              idAlertnow: tmpan,
              id: "",
            });
        });
        this.translatesFormGroup.patchValue({
          url: service.url,
          translates,
        });
        this.logoFormGroup.patchValue({
          logo: service.logo,
        });
        this.logoBase64 = "data:image/png;base64," + service.logo;
      }
      if (this.areaID != null) {
        this.areaFormGroup = this.formBuilder.group({
          idArea: [this.areaID, Validators.required],
        });
      } else {
        this.areaFormGroup = this.formBuilder.group({
          idArea: [null, Validators.required],
        });
      }
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  onBackButtonClick() {
    this.router.navigate(["/services"]);
  }

  get translates() {
    return this.translatesFormGroup.get("translates") as FormArray;
  }

  handleFileInput(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.logoBase64 = reader.result.toString();
      this.logoFormGroup.patchValue({
        logo: this.logoBase64.split(",")[1], // Manipolazione delicata.
      });
    };
  }

  onAreaChanged(area) {
    this.areaFormGroup.patchValue({
      idArea: area[0]?.id,
    });
  }

  onServiceSave() {
    const translatesFormValue = this.translatesFormGroup.value;
    const logoFormValue = this.logoFormGroup.value;
    const areaFormValue = this.areaFormGroup.value;
    this.loading = true;
    if (this.localIDService == null) return;
    const serviceInsertRequest: ServiceInsertRequest = {
      id: this.localIDService,
      idType: sessionStorage.getItem("latestServiceType"),
      idArea: areaFormValue.idArea,
      idCategory: 1,
      url: translatesFormValue.url,
      logo: logoFormValue.logo,
      translates: translatesFormValue.translates,
    };
    this.adminService.updateService(serviceInsertRequest).subscribe(
      (response) => {
        this.loading = false;
        this.openSnackBar("Servizio Modificato con successo.", "Chiudi");
        this.router.navigate(["/services"]);
      },
      (err) => {
        this.loading = false;
        this.genericErrorModalService.open(
          "Errore durante la modifica del Servizio Geolocalizzato",
          err
        );
      }
    );
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3500,
      panelClass: "custom-snackbar",
    });
  }
}
